import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tccg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Fire-and-forget click tracking (backend + GA + Meta pixel)
export function trackClick({ item_type, item_id, item_name, url }) {
  try {
    api.post("/track", { item_type, item_id, item_name, url }).catch(() => {});
    if (window.gtag) {
      window.gtag("event", "select_content", {
        content_type: item_type,
        item_id: item_name,
      });
    }
    if (window.fbq) window.fbq("trackCustom", "LinkClick", { item_type, item_name });
  } catch (e) {
    /* noop */
  }
}

// Normalise a URL that might be a bare domain (e.g. "rewardpoints.club") so
// window.open + <a href> never treat it as a relative path (which would send
// visitors to linkitnow.in/rewardpoints.club instead of the actual site).
// Mirrors backend `normalize_external_url` — one source of truth per side.
const URL_SAFE_SCHEMES = /^(https?:|mailto:|tel:|sms:|whatsapp:)/i;
export function normalizeExternalUrl(url) {
  if (!url) return "";
  const u = String(url).trim();
  if (!u) return "";
  if (u.startsWith("//")) return "https:" + u;
  if (u.startsWith("#") || u.startsWith("/")) return u;
  if (URL_SAFE_SCHEMES.test(u)) return u;
  return "https://" + u;
}

// Track + open external link in new tab
export function openTrackedLink(url, meta) {
  const normalized = normalizeExternalUrl(url);
  trackClick({ ...meta, url: normalized });
  if (normalized) window.open(normalized, "_blank", "noopener,noreferrer");
}

// Resolve stored image url (absolute http/blob/data used as-is; relative prefixed with backend)
export function resolveImg(url) {
  if (!url) return "";
  if (/^(https?:|blob:|data:)/.test(url)) return url;
  return `${BACKEND_URL}${url}`;
}

// Admin image upload -> returns absolute URL to store
export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return `${BACKEND_URL}${data.url}`;
}
